import React from "react";

const InternalMessage = () => {
  return (
    <div
      id="mc-animate-container"
      className="v-base v-detail-base fade-enter-done"
    >
      <section
        className="webMail"
        style={{ height: "100%", background: "rgb(255, 255, 255)" }}
      >
        <header className="mc-header-wrap">
          <div
            className="mc-navbar-blue mc-profitandloss am-navbar am-navbar-light mc-default-header"
            id="mc-header"
          >
            <div className="am-navbar-left return_icon">
              <svg className="am-icon am-icon-left am-icon-lg">
                <use xlinkHref="#left" />
              </svg>
            </div>
            <div className="am-navbar-title">Internal Message</div>
            <div className="am-navbar-right" />
          </div>
        </header>
        <div className="am-tabs am-tabs-top">
          <div role="tablist" className="am-tabs-bar" tabIndex={0}>
            <div
              className="am-tabs-ink-bar am-tabs-ink-bar-no-animated"
              style={{
                display: "block",
                "-webkit-transform": "translate3d(0px, 0px, 0px)",
                "-ms-transform": "translate3d(0px, 0px, 0px)",
                transform: "translate3d(0px, 0px, 0px)",
                width: "0px",
              }}
            />
            <div
              role="tab"
              aria-disabled="false"
              aria-selected="true"
              className="am-tabs-tab-active am-tabs-tab"
            >
              <div className="EmailMessage">
                <i />
                {/* react-text: 8586 */}Inbox{/* /react-text */}
              </div>
            </div>
          </div>
          <div className="am-tabs-content am-tabs-content-no-animated">
            <div
              role="tabpanel"
              aria-hidden="false"
              className="am-tabs-tabpane am-tabs-tabpane-active"
            >
              <div
                style={{
                  display: "flex",
                  "-webkit-align-items": "center",
                  "-webkit-box-align": "center",
                  "-ms-flex-align": "center",
                  "align-items": "center",
                  "-webkit-box-pack": "center",
                  "-webkit-justify-content": "center",
                  "-ms-flex-pack": "center",
                  "justify-content": "center",
                }}
              >
                <div className="getMail">
                  <div className="getDit">
                    <div className="status">
                      <span className="all">
                        <label className="am-checkbox-wrapper">
                          <span className="am-checkbox">
                            <input
                              type="checkbox"
                              className="am-checkbox-input"
                              defaultValue="on"
                            />
                            <span className="am-checkbox-inner" />
                          </span>
                          {/* react-text: 8598 */}Select all{/* /react-text */}
                        </label>
                      </span>
                      <div className="right-com">
                        <span className="label-read ">
                          <svg className="am-icon am-icon-mail-read_c8afd723 am-icon-md">
                            <use xlinkHref="#mail-read_c8afd723" />
                          </svg>
                        </span>
                        <span className="del ">
                          <svg className="am-icon am-icon-mail-delete_49fd10ef am-icon-md delete-icon">
                            <use xlinkHref="#mail-delete_49fd10ef" />
                          </svg>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="EmailList">
                    <div
                      className="list-wrapper"
                      style={{
                        height:
                          "calc(100 * var(--vh, 1vh) - 133.9166717529297PX)",
                      }}
                    >
                      <ul
                        className="scroll-inner-container"
                        style={{
                          "-webkit-transition-timing-function":
                            "cubic-bezier(0.165, 0.84, 0.44, 1)",
                          "transition-timing-function":
                            "cubic-bezier(0.165, 0.84, 0.44, 1)",
                          "-webkit-transition-duration": "0ms",
                          "transition-duration": "0ms",
                          "-webkit-transform":
                            "translate(0px) scale(1) translateZ(0px)",
                          "-ms-transform":
                            "translate(0px) scale(1) translateZ(0px)",
                          transform: "translate(0px) scale(1) translateZ(0px)",
                        }}
                      >
                        <li>
                          <div className="EmaiWebList ">
                            <div className="am-flexbox am-flexbox-align-middle">
                              <div className="am-flexbox-item">
                                <div
                                  data-seed="logId"
                                  className="am-checkbox-agree"
                                >
                                  <label className="am-checkbox-agree-label am-checkbox-wrapper">
                                    <span className="am-checkbox">
                                      <input
                                        type="checkbox"
                                        className="am-checkbox-input"
                                        data-seed="logId"
                                        defaultValue="on"
                                      />
                                      <span className="am-checkbox-inner" />
                                    </span>
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="mail-info">
                              <div className="am-list-item am-list-item-top">
                                <div className="am-list-thumb">
                                  <span className="look am-badge am-badge-not-a-wrapper">
                                    <sup className="am-badge-dot" />
                                  </span>
                                </div>
                                <div className="am-list-line am-list-line-multiple">
                                  <div className="am-list-content">
                                    Sender:Platform
                                  </div>
                                  <div className="am-list-extra">
                                    2025-11-18 14:41:35
                                  </div>
                                  <div
                                    className="am-list-arrow am-list-arrow-horizontal"
                                    aria-hidden="true"
                                  />
                                </div>
                                <div
                                  className="am-list-ripple"
                                  style={{ display: "none" }}
                                />
                              </div>
                              <div className="am-list-brief">
                                {/* react-text: 8630 */}Title{/* /react-text */}
                                {/* react-text: 8631 */}:{/* /react-text */}
                                {/* react-text: 8632 */}ব্যবহারকারী সুরক্ষা
                                বার্তা{/* /react-text */}
                              </div>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="EmaiWebList ">
                            <div className="am-flexbox am-flexbox-align-middle">
                              <div className="am-flexbox-item">
                                <div
                                  data-seed="logId"
                                  className="am-checkbox-agree"
                                >
                                  <label className="am-checkbox-agree-label am-checkbox-wrapper">
                                    <span className="am-checkbox">
                                      <input
                                        type="checkbox"
                                        className="am-checkbox-input"
                                        data-seed="logId"
                                        defaultValue="on"
                                      />
                                      <span className="am-checkbox-inner" />
                                    </span>
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="mail-info">
                              <div className="am-list-item am-list-item-top">
                                <div className="am-list-thumb">
                                  <span className="look am-badge am-badge-not-a-wrapper">
                                    <sup className="am-badge-dot" />
                                  </span>
                                </div>
                                <div className="am-list-line am-list-line-multiple">
                                  <div className="am-list-content">
                                    Sender:Platform
                                  </div>
                                  <div className="am-list-extra">
                                    2025-11-17 14:06:29
                                  </div>
                                  <div
                                    className="am-list-arrow am-list-arrow-horizontal"
                                    aria-hidden="true"
                                  />
                                </div>
                                <div
                                  className="am-list-ripple"
                                  style={{ display: "none" }}
                                />
                              </div>
                              <div className="am-list-brief">
                                {/* react-text: 8653 */}Title{/* /react-text */}
                                {/* react-text: 8654 */}:{/* /react-text */}
                                {/* react-text: 8655 */}ব্যবহারকারী সুরক্ষা
                                বার্তা{/* /react-text */}
                              </div>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="EmaiWebList ">
                            <div className="am-flexbox am-flexbox-align-middle">
                              <div className="am-flexbox-item">
                                <div
                                  data-seed="logId"
                                  className="am-checkbox-agree"
                                >
                                  <label className="am-checkbox-agree-label am-checkbox-wrapper">
                                    <span className="am-checkbox">
                                      <input
                                        type="checkbox"
                                        className="am-checkbox-input"
                                        data-seed="logId"
                                        defaultValue="on"
                                      />
                                      <span className="am-checkbox-inner" />
                                    </span>
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="mail-info">
                              <div className="am-list-item am-list-item-top">
                                <div className="am-list-thumb">
                                  <span className="look am-badge am-badge-not-a-wrapper">
                                    <sup className="am-badge-dot" />
                                  </span>
                                </div>
                                <div className="am-list-line am-list-line-multiple">
                                  <div className="am-list-content">
                                    Sender:Platform
                                  </div>
                                  <div className="am-list-extra">
                                    2025-11-16 14:36:03
                                  </div>
                                  <div
                                    className="am-list-arrow am-list-arrow-horizontal"
                                    aria-hidden="true"
                                  />
                                </div>
                                <div
                                  className="am-list-ripple"
                                  style={{ display: "none" }}
                                />
                              </div>
                              <div className="am-list-brief">
                                {/* react-text: 8676 */}Title{/* /react-text */}
                                {/* react-text: 8677 */}:{/* /react-text */}
                                {/* react-text: 8678 */}ব্যবহারকারী সুরক্ষা
                                বার্তা{/* /react-text */}
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                      <div className="pullup-wrapper" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default InternalMessage;
